export const randomESTBids = () => (Math.random() * (3.28 - 1.51) + 1.51).toFixed(2);
